import styled from 'styled-components';
import { Accordion } from '@tvg/fuse-design';

export const StyledAccordion = styled(Accordion)`
  &:last-of-type {
    border-bottom: none !important;
  }
  h2 {
    button {
      span {
        color: var(--color-font-heading) !important;
      }
      &::after {
        background: var(--color-font-heading) !important;
      }
    }
  }
`;

export const FeaturesContainer = styled.div`
  position: relative;
  z-index: 0;
  padding-top: var(--spacing-space16);

  h3 {
    font-family: var(--font-brand);
    font-size: var(--font-size-m1);
    line-height: var(--font-line-height-m1);
    font-weight: bold !important;
    margin-bottom: var(--spacing-space4);
    color: var(--color-base-black);
  }

  p {
    margin-bottom: var(--spacing-space12);
    color: var(--color-global-grey900) !important;
  }
`;

export const Container = styled.div`
  position: relative;
  z-index: 0;
`;

export const AccordionWrapperDiv = styled.div`
  border-bottom: 1px solid var(--color-global-grey400);
  margin-top: var(--spacing-space32);
  margin-bottom: var(--spacing-space32);
`;

export const LinksContainer = styled.div`
  position: relative;
  z-index: 0;
  padding-top: var(--spacing-global-space4);

  a {
    margin: 0 0 var(--spacing-global-space6) !important;
  }
`;

export const TechSpecsContainer = styled.div`
  position: relative;
  z-index: 0;
  padding-top: var(--spacing-space16);

  .ccs-ds-mainSpec-area table td {
    border: 1px solid #d3d3d3;
    padding-bottom: 12px;
    padding-right: 16px;
    padding-top: 12px;
    text-align: left;
    vertical-align: top;
    padding-left: 16px;
  }
  .ccs-ds-mainSpec-item {
    width: 50%;
    font-weight: var(--font-weight-heading);
    font-family: var(--font-brand);
    font-size: var(--font-size-m1);
    line-height: var(--font-line-height-m1);
    color: var(--color-base-black);
  }
  .ccs-ds-mainSpec-value {
    width: 50%;
    font-family: var(--font-brand);
    font-size: var(--font-size-m1);
    line-height: var(--font-line-height-m1);
    font-weight: var(--font-weight-paragraph);
    color: var(--color-global-grey900);
  }

  table {
    tbody {
      tr:nth-child(even) {
        background-color: #f6f6f6;
      }
    }
  }
`;

export const DocsContainer = styled.div`
  position: relative;
  z-index: 0;
  display: none;
  a {
    span {
      color: var(--color-global-grey900);
      text-decoration-line: underline;
      text-decoration-color: var(--color-global-grey500);
      text-decoration-style: solid;
      text-decoration-thickness: 1px;
      line-height: calc(var(--font-line-height-m1) + 2px);
      text-underline-offset: 5px;
      font-size: var(--font-size-m1);
      position: relative;
    }
  }
`;
